import swal from "sweetalert2";
<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-2">
        <h4 class="card-title text-left">아티스트명</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="아티스트명" v-model="name">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <h4 class="card-title text-left">설명</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="설명" v-model="description">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="addBlackName" type="default">추가</base-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <el-table :data="data">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="100" align="right" label="삭제">
          <div slot-scope="props">
            <base-button @click.native="deleteBlackName(props.row.id)" type="warning" size="sm" icon>
              <i class="tim-icons icon-simple-delete" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BaseInput } from "@/components/index";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import swal from "sweetalert2";

export default {
  components: {
    BaseInput,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.getBlackList();
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "name",
          label: "아티스트명",
          minWidth: 100,
        },
        {
          prop: "description",
          label: "경고표시내용",
          minWidth: 100,
        },
      ],
      data: [],
      name: null,
      description: null,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getBlackList();
      },
    },
  },
  methods: {
    async getBlackList() {
      return this.$axios.get("/artistUnit/blackList").then((res) => {
        this.data = res.data.data;
      });
    },
    async addBlackName() {
      if (this.name === "" || !this.name) {
        Toast.error("키워드를 입력해주세요");
        return;
      }
      const params = { name: this.name, description: this.description };
      try {
        await this.$axios.post("/artistUnit/blackList", { params });
        Toast.success("추가되었습니다");
        this.name = null;
        this.description = null;
        await this.getBlackList();
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async deleteBlackName(id) {
      swal
        .fire({
          title: "삭제 확인",
          text: `${id} 키워드 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const params = { id };
              await this.$axios.delete("/artistUnit/blackList", { params });
              Toast.success("삭제되었습니다");

              await this.getBlackList();
            } catch (err) {
              Toast.error("키워드 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
